import { Input, InputProps, InputRef } from "antd";
import { NUMBER_ONLY_REGEX, NUMBER_REGEX } from "constants/common";
import React, { Ref } from "react";

function checkStringNumber(
  value: string,
  { onlyNumber }: { onlyNumber?: boolean }
) {
  if (onlyNumber) {
    if (NUMBER_ONLY_REGEX.test(value)) {
      return true;
    }

    return false;
  }

  if (NUMBER_REGEX.test(value)) {
    return true;
  }
  return false;
}

type TInputOnlyNumberMainProps = InputProps & {
  onlyNumber?: boolean;
};

function InputOnlyNumberMain(
  props: TInputOnlyNumberMainProps,
  ref?: Ref<InputRef>
) {
  const { onChange, onBlur, id, onlyNumber, value = "", ...restProps } = props;

  return (
    <Input
      {...restProps}
      id={id}
      ref={ref}
      value={value}
      onBlur={onBlur}
      onChange={(e) => {
        const isValidNumber = checkStringNumber(e.target.value, {
          onlyNumber,
        });

        if (!isValidNumber) {
          e.preventDefault();
        } else {
          onChange?.(e);
        }
      }}
    />
  );
}

const InputOnlyNumber = React.forwardRef(InputOnlyNumberMain);

export { InputOnlyNumber };
